import ServiceLocator from 'live/services/service-locator'
import i18n from 'live/services/i18n'
import * as Permission from '../permission'

import DataAggregation from './data-aggregation'

import { getAssetTypes } from './api'

try {
    ServiceLocator.getService('asset-tab-service').then(service => {
        const assetTypesPromise = getAssetTypes()

        assetTypesPromise.then(assetTypes => {
            assetTypes.forEach(assetType => {
                service.register({
                    step: `data-aggregation-${assetType}`,
                    assetType: `${assetType}${assetType === 'well' ? 's' : ''}`,
                    label: i18n('Data Aggregations'),
                    shouldHide: !Permission.canViewAggregations(),
                    body: DataAggregation
                })
            })
        })
    })
} catch (e) {
    console.error(e)
}
